<div class="site-page-header-ghost-wrapper">
    <nz-page-header nzBackIcon [nzGhost]="false">
        <nz-page-header-title>Exportações</nz-page-header-title>
        <nz-page-header-subtitle class="hide-xs"> - Lista de arquivos de exportações.</nz-page-header-subtitle>
    </nz-page-header>
    <div nz-row [nzGutter]="12">
        <div nz-col nzMd="24" nzXs="24" style="margin-bottom: 20px;">
            <form nz-form nzLayout="inline">
                <div nz-col nzMd="5" nzXs="12">
                    <nz-form-label>Data Inicial (Geração)</nz-form-label>
                    <nz-form-item>
                        <nz-form-control nzHasFeedback nzErrorTip="Data Inválida!">
                            <input nz-input type="date" name="pesquisaDataInicial" [(ngModel)]="pesquisaDataInicial" placeholder="00/00/0000" />
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzMd="5" nzXs="12">
                    <nz-form-label>Data Final (Geração)</nz-form-label>
                    <nz-form-item>
                        <nz-form-control nzHasFeedback nzErrorTip="Data Inválida!">
                            <input nz-input type="date" name="pesquisaDataFinal" [(ngModel)]="pesquisaDataFinal" placeholder="00/00/0000" />
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzMd="5" nzXs="24">
                    <p style="color:white; margin-bottom: 10px!important;">-</p>
                    <button nz-button nzType="primary" (click)="pesquisar()" nzBlock nzSearch>Pesquisar</button>
                </div>
                <div nz-col nzMd="5" nzXs="24">
                    <p style="color:white; margin-bottom: 10px!important;">-</p>
                    <button nz-button nzType="default" [disabled]="!pesquisaDataFinal" (click)="cancelarPesquisa()" nzBlock nzSearch style="color:#c0392b;">Cancelar Pesquisa</button>
                </div>
            </form>
        </div>

        <div nz-col nzMd="24" nzXs="24">
            <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="exportacoes" [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Gerado em</th>
                        <th>Período</th>
                        <th>Solicitador</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                        <tr>
                            <td class="hide-xs">
                                <span>
                                    <nz-badge *ngIf="data.status === 'PROCESSANDO'" nzStatus="processing" nz-tooltip
                                        nzTooltipTitle="Processando..."></nz-badge>
                                    <nz-badge *ngIf="data.status === 'CONCLUIDO'" nzStatus="success" nz-tooltip
                                        nzTooltipTitle="Concluído"></nz-badge>
                                    <nz-badge *ngIf="data.status === 'FALHA'" nzStatus="warning" nz-tooltip
                                        nzTooltipTitle="Houve uma falha ao gerar a exportação, entre em contato com o administrador do sistema."></nz-badge>
                                    {{ data.idxlsx_medicamento_importacao }}
                                </span>
                            </td>
                            <td class="hide-xs">
                                <span> {{ data.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                            </td>
                            <td>
                                {{data.data_inicial | date: 'dd/MM/yyyy'}} - {{data.data_final | date: 'dd/MM/yyyy'}}
                            </td>
                            <td>
                                <span nz-icon nzType="user" nzTheme="outline"></span> {{data.solicitador?.name}}
                            </td>

                            <td>
                                <button nz-button nzType="default" (click)="download(data.idexportacao_lead, 'exportacao_leads_' + data.data_inicial + '_' + data.data_final + '.csv')"><span nz-icon nzType="download" nzTheme="outline"></span> Download</button>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </nz-table>
        </div>
    </div>